import { css } from 'styled-components';
import { StyledGrid } from '../../../../../components/Footer/CustomisableFooter/styles';
import colors from '../../../../../helpers/colors';

export default css`
  ${StyledGrid} {
    a {
      color: ${colors.core01};
    }
  }
`;
